import { UrbanBathroomContainer } from '../../containers/advancedFilters/UrbanBathroomContainer';
import { IFilter } from '../../types/advancedFilters';

export const urbanBathroom: IFilter = {
  component: UrbanBathroomContainer,
};
